// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eBCB","top":"styles_top__1ieAV"};